import { useEffect, useState } from "react";
import { Loader2, Save } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api, errMsg } from "@/lib/api";

export const SettingsPanel = () => {
  const [s, setS] = useState(null);
  const [ann, setAnn] = useState(null);
  const [mt, setMt] = useState(null);
  useEffect(() => {
    api.get("/superadmin/settings").then(({ data }) => { setS({ trial_days: data.trial_days, grace_days: data.grace_days }); setAnn(data.announcement); setMt(data.maintenance); })
      .catch((e) => toast.error(errMsg(e)));
  }, []);
  if (!s) return <Loader2 className="h-5 w-5 animate-spin text-slate-400" />;
  const saveSettings = () => api.put("/superadmin/settings", { trial_days: Number(s.trial_days), grace_days: Number(s.grace_days) })
    .then(() => toast.success("Réglages enregistrés")).catch((e) => toast.error(errMsg(e)));
  const saveAnn = () => api.put("/superadmin/announcement", ann)
    .then(() => toast.success(ann.active ? "Message affiché chez tous vos clients" : "Message masqué")).catch((e) => toast.error(errMsg(e)));
  const saveMt = () => api.put("/superadmin/maintenance", mt)
    .then(({ data }) => { setMt(data); toast.success(data.active ? "Page de maintenance activée" : "Site public rétabli"); }).catch((e) => toast.error(errMsg(e)));
  return (
    <div className="space-y-6 max-w-2xl" data-testid="sa-settings">
      <section className={`rounded-lg border p-6 space-y-4 ${mt.active ? "border-amber-300 bg-amber-50" : "border-slate-200"}`} data-testid="maintenance-section">
        <div className="flex items-center justify-between gap-4">
          <h3 className="font-semibold">Page de maintenance</h3>
          <label className="flex items-center gap-2 text-sm font-medium"><Switch checked={mt.active} onCheckedChange={(v) => setMt({ ...mt, active: v })} data-testid="maintenance-active" />{mt.active ? "Activée" : "Désactivée"}</label>
        </div>
        <p className="text-sm text-slate-500">Remplace la page d'accueil et l'inscription par une page de maintenance. La connexion à l'espace client, les agents installés et les sessions d'assistance continuent de fonctionner.</p>
        <Textarea value={mt.message} maxLength={600} onChange={(e) => setMt({ ...mt, message: e.target.value })} data-testid="maintenance-message-input" />
        <div className="flex gap-3">
          <Button onClick={saveMt} data-testid="maintenance-save"><Save className="h-4 w-4 mr-2" />Enregistrer</Button>
          <Button asChild variant="outline"><a href="/" target="_blank" rel="noreferrer" data-testid="maintenance-view">Voir le site</a></Button>
        </div>
      </section>
      <section className="rounded-lg border border-slate-200 p-6 space-y-4">
        <h3 className="font-semibold">Essai gratuit et impayés</h3>
        <div className="grid sm:grid-cols-2 gap-4">
          <label className="block"><span className="text-xs text-slate-500">Durée de l'essai gratuit (jours, nouveaux comptes)</span>
            <Input type="number" min="1" max="90" className="mt-1" value={s.trial_days} onChange={(e) => setS({ ...s, trial_days: e.target.value })} data-testid="settings-trial-days" /></label>
          <label className="block"><span className="text-xs text-slate-500">Délai avant coupure après un paiement refusé (jours)</span>
            <Input type="number" min="0" max="60" className="mt-1" value={s.grace_days} onChange={(e) => setS({ ...s, grace_days: e.target.value })} data-testid="settings-grace-days" /></label>
        </div>
        <Button onClick={saveSettings} data-testid="settings-save"><Save className="h-4 w-4 mr-2" />Enregistrer</Button>
      </section>
      <section className="rounded-lg border border-slate-200 p-6 space-y-4">
        <h3 className="font-semibold">Message à tous les clients</h3>
        <p className="text-sm text-slate-500">Bandeau affiché en haut de ScreenView chez tous vos clients (maintenance, nouveauté…).</p>
        <Input placeholder="Ex. Maintenance prévue dimanche de 22 h à 23 h" value={ann.text} maxLength={400} onChange={(e) => setAnn({ ...ann, text: e.target.value })} data-testid="announcement-text" />
        <div className="flex flex-wrap items-center gap-4">
          <Select value={ann.level} onValueChange={(v) => setAnn({ ...ann, level: v })}>
            <SelectTrigger className="w-48" data-testid="announcement-level"><SelectValue /></SelectTrigger>
            <SelectContent><SelectItem value="info">Information (bleu)</SelectItem><SelectItem value="warning">Important (orange)</SelectItem></SelectContent>
          </Select>
          <label className="flex items-center gap-2 text-sm"><Switch checked={ann.active} onCheckedChange={(v) => setAnn({ ...ann, active: v })} data-testid="announcement-active" />Afficher</label>
        </div>
        <Button onClick={saveAnn} data-testid="announcement-save"><Save className="h-4 w-4 mr-2" />Publier</Button>
      </section>
    </div>
  );
};
